<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="600"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="observer">
      <v-form>
        <v-card
          v-if="manifestId"
          flat
        >
          <v-card-title v-if="customLabel.use_title">{{ customLabel.name_title }}</v-card-title>
          <v-divider />
          <v-card-text>
            <!-- ラベル１ -->
            <v-row v-if="customLabel.custom_labels1_use">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="custom_labels1"
                  :name="customLabel.custom_labels1_name"
                  :rules="{ required: customLabel.custom_labels1_required,
                        alpha_num_only: customLabel.custom_labels1_halfsize_alphanumeric,
                        max: customLabel.custom_labels1_maximum_characters != null ? customLabel.custom_labels1_maximum_characters : 255 ,
                        min: customLabel.custom_labels1_minimum_characters != null ? customLabel.custom_labels1_minimum_characters : 0
                  }"
                >
                  <v-text-field
                    v-model="forms.custom_labels_1"
                    :error-messages="errors"
                    :label="customLabel.custom_labels1_name"
                    dense
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>{{ customLabel.custom_labels1_name }}</span>
                      <span class="ml-1">
                        ({{ forms.custom_labels_1?.length || 0 }} 
                        / {{ customLabel.custom_labels1_maximum_characters != null ? customLabel.custom_labels1_maximum_characters : 255 }})
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /ラベル１ -->

            <!-- ラベル２ -->
            <v-row v-if="customLabel.custom_labels2_use">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="custom_labels2"
                  :name="customLabel.custom_labels2_name"
                  :rules="{ required: customLabel.custom_labels2_required,
                        alpha_num_only: customLabel.custom_labels2_halfsize_alphanumeric,
                        max: customLabel.custom_labels2_maximum_characters != null ? customLabel.custom_labels2_maximum_characters : 255 ,
                        min: customLabel.custom_labels2_minimum_characters != null ? customLabel.custom_labels2_minimum_characters : 0
                  }"
                >
                  <v-text-field
                    v-model="forms.custom_labels_2"
                    :error-messages="errors"
                    :label="customLabel.custom_labels2_name"
                    dense
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>{{ customLabel.custom_labels2_name }}</span>
                      <span class="ml-1">
                        ({{ forms.custom_labels_2?.length || 0 }} 
                        / {{ customLabel.custom_labels2_maximum_characters != null ? customLabel.custom_labels2_maximum_characters : 255 }})
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /ラベル２ -->

            <!-- ラベル３ -->
            <v-row v-if="customLabel.custom_labels3_use">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="custom_labels3"
                  :name="customLabel.custom_labels3_name"
                  :rules="{ required: customLabel.custom_labels3_required,
                        alpha_num_only: customLabel.custom_labels3_halfsize_alphanumeric,
                        max: customLabel.custom_labels3_maximum_characters != null ? customLabel.custom_labels3_maximum_characters : 255 ,
                        min: customLabel.custom_labels3_minimum_characters != null ? customLabel.custom_labels3_minimum_characters : 0
                  }"
                >
                  <v-text-field
                    v-model="forms.custom_labels_3"
                    :error-messages="errors"
                    :label="customLabel.custom_labels3_name"
                    dense
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>{{ customLabel.custom_labels3_name }}</span>
                      <span class="ml-1">
                        ({{ forms.custom_labels_3?.length || 0 }} 
                        / {{ customLabel.custom_labels3_maximum_characters != null ? customLabel.custom_labels3_maximum_characters : 255 }})
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /ラベル３ -->

            <!-- ラベル４ -->
            <v-row v-if="customLabel.custom_labels4_use">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="custom_labels4"
                  :name="customLabel.custom_labels4_name"
                  :rules="{ required: customLabel.custom_labels4_required,
                        alpha_num_only: customLabel.custom_labels4_halfsize_alphanumeric,
                        max: customLabel.custom_labels4_maximum_characters != null ? customLabel.custom_labels4_maximum_characters : 255 ,
                        min: customLabel.custom_labels4_minimum_characters != null ? customLabel.custom_labels4_minimum_characters : 0
                  }"
                >
                  <v-text-field
                    v-model="forms.custom_labels_4"
                    :error-messages="errors"
                    :label="customLabel.custom_labels4_name"
                    dense
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>{{ customLabel.custom_labels4_name }}</span>
                      <span class="ml-1">
                        ({{ forms.custom_labels_4?.length || 0 }} 
                        / {{ customLabel.custom_labels4_maximum_characters != null ? customLabel.custom_labels4_maximum_characters : 255 }})
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /ラベル４ -->

            <!-- ラベル５ -->
            <v-row v-if="customLabel.custom_labels5_use">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="custom_labels5"
                  :name="customLabel.custom_labels5_name"
                  :rules="{ required: customLabel.custom_labels5_required,
                        alpha_num_only: customLabel.custom_labels5_halfsize_alphanumeric,
                        max: customLabel.custom_labels5_maximum_characters != null ? customLabel.custom_labels5_maximum_characters : 255 ,
                        min: customLabel.custom_labels5_minimum_characters != null ? customLabel.custom_labels5_minimum_characters : 0
                  }"
                >
                  <v-text-field
                    v-model="forms.custom_labels_5"
                    :error-messages="errors"
                    :label="customLabel.custom_labels5_name"
                    dense
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  > 
                    <template v-slot:label>
                      <span>{{ customLabel.custom_labels5_name }}</span>
                      <span class="ml-1">
                        ({{ forms.custom_labels_5?.length || 0 }} 
                        / {{ customLabel.custom_labels5_maximum_characters != null ? customLabel.custom_labels5_maximum_characters : 255 }})
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /ラベル５ -->

            <!-- ラベル６ -->
            <v-row v-if="customLabel.custom_labels6_use">
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="custom_labels6"
                  :name="customLabel.custom_labels6_name"
                  :rules="{ required: customLabel.custom_labels6_required,
                        alpha_num_only: customLabel.custom_labels6_halfsize_alphanumeric,
                        max: customLabel.custom_labels6_maximum_characters != null ? customLabel.custom_labels6_maximum_characters : 255 ,
                        min: customLabel.custom_labels6_minimum_characters != null ? customLabel.custom_labels6_minimum_characters : 0
                  }"
                >
                  <v-text-field
                    v-model="forms.custom_labels_6"
                    :error-messages="errors"
                    :label="customLabel.custom_labels6_name"
                    dense
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>{{ customLabel.custom_labels6_name }}</span>
                      <span class="ml-1">
                        ({{ forms.custom_labels_6?.length || 0 }} 
                        / {{ customLabel.custom_labels6_maximum_characters != null ? customLabel.custom_labels6_maximum_characters : 255 }})
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /ラベル６ -->
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              更新
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "EditManifestCustomLabelDialog",
  components: {},
  mixins: [],
  props: {
    manifestId: {
      type: Number,
      default: () => null,
    },
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    customLabel: {},
  },
  data() {
    return {
      forms: {
        custom_labels_1: null,
        custom_labels_2: null,
        custom_labels_3: null,
        custom_labels_4: null,
        custom_labels_5: null,
        custom_labels_6: null,
      }
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      if (newValue) {
        this.setVariable()
      }

    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestManagementManifestCustomLabel', {
      fetchManifestCustomLabel: 'edit',
      updateManifestCustomLabel: 'update'
    }),
    /**
     * 初期値を取得/設定
     */
    setVariable () {
      this.fetchManifestCustomLabel({ id: this.manifestId }).then((content) => {
        this.forms = content
      })
    },
    /**
     * 閉じるボタン クリックイベント
     * @description 呼び出し元で設定されたコールバックを呼び出します.
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validateWithInfo().then(({ isValid, errors }) => {
        if(isValid) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {

      let params = this.forms
      this.updateManifestCustomLabel({ id: this.manifestId, params: params }).then(() => {
        this.$emit('registerCallback')
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
